"use strict";

function _typeof(obj) { "@babel/helpers - typeof"; return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (obj) { return typeof obj; } : function (obj) { return obj && "function" == typeof Symbol && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; }, _typeof(obj); }
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
var _jsxRuntime = require("react/jsx-runtime");
var _Group = _interopRequireDefault(require("../Group/Group"));
var _react = require("react");
var Contexts = _interopRequireWildcard(require("../../contexts"));
var Hooks = _interopRequireWildcard(require("../../hooks"));
var FSTypes = _interopRequireWildcard(require("../../types"));
function _getRequireWildcardCache(nodeInterop) { if (typeof WeakMap !== "function") return null; var cacheBabelInterop = new WeakMap(); var cacheNodeInterop = new WeakMap(); return (_getRequireWildcardCache = function _getRequireWildcardCache(nodeInterop) { return nodeInterop ? cacheNodeInterop : cacheBabelInterop; })(nodeInterop); }
function _interopRequireWildcard(obj, nodeInterop) { if (!nodeInterop && obj && obj.__esModule) { return obj; } if (obj === null || _typeof(obj) !== "object" && typeof obj !== "function") { return { default: obj }; } var cache = _getRequireWildcardCache(nodeInterop); if (cache && cache.has(obj)) { return cache.get(obj); } var newObj = {}; var hasPropertyDescriptor = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var key in obj) { if (key !== "default" && Object.prototype.hasOwnProperty.call(obj, key)) { var desc = hasPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : null; if (desc && (desc.get || desc.set)) { Object.defineProperty(newObj, key, desc); } else { newObj[key] = obj[key]; } } } newObj.default = obj; if (cache) { cache.set(obj, newObj); } return newObj; }
function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
var __assign = void 0 && (void 0).__assign || function () {
  __assign = Object.assign || function (t) {
    for (var s, i = 1, n = arguments.length; i < n; i++) {
      s = arguments[i];
      for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p)) t[p] = s[p];
    }
    return t;
  };
  return __assign.apply(this, arguments);
};
var __rest = void 0 && (void 0).__rest || function (s, e) {
  var t = {};
  for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0) t[p] = s[p];
  if (s != null && typeof Object.getOwnPropertySymbols === "function") for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
    if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i])) t[p[i]] = s[p[i]];
  }
  return t;
};
var Form = /*#__PURE__*/(0, _react.forwardRef)(function (props, ref) {
  var children = props.children,
    defaultValue = props.defaultValue,
    disabled = props.disabled,
    i18n = props.i18n,
    initialValue = props.initialValue,
    onCancel = props.onCancel,
    onChange = props.onChange,
    onDelete = props.onDelete,
    onSubmit = props.onSubmit,
    formProps = __rest(props, ["children", "defaultValue", "disabled", "i18n", "initialValue", "onCancel", "onChange", "onDelete", "onSubmit"]);
  var formContextValue = Hooks.useBuildFormContext({
    defaultValue: defaultValue,
    disabled: disabled,
    i18n: i18n,
    initialValue: initialValue,
    onCancel: onCancel,
    onChange: onChange,
    onDelete: onDelete
  });
  var onSubmitLocal = (0, _react.useCallback)(function (event) {
    event.preventDefault();
    formContextValue.setIsSubmitting(true);
    formContextValue.clearAllValidationMessages("all");
    var validationMessages = formContextValue.validateForm(formContextValue.getFormData());
    var isValid = validationMessages.reduce(function (isValidSoFar, validationMessage) {
      return isValidSoFar && validationMessage.type !== FSTypes.ValidationTypes.Error;
    }, true);
    if (onSubmit) {
      onSubmit(formContextValue.getFormData(), isValid, validationMessages, function () {
        formContextValue.setIsSubmitting(false);
      });
    }
  }, [formContextValue, onSubmit]);
  return (0, _jsxRuntime.jsx)("form", __assign({
    ref: ref,
    onSubmit: onSubmitLocal
  }, formProps, {
    children: (0, _jsxRuntime.jsx)(_Group.default, __assign({
      direction: "vertical"
    }, {
      children: (0, _jsxRuntime.jsx)(Contexts.FormContext.Provider, __assign({
        value: formContextValue
      }, {
        children: children
      }))
    }))
  }));
});
var _default = Form;
exports.default = _default;